<div>
  <div class="wording">Plusieurs cartes CPE/CPS sont présentes.</div>
  <div class="wording">Veuillez sélectionner la carte désirée dans la liste suivantes</div>
  <frg-form-input
    *ngIf="formGroup"
    [formGroup]="formGroup"
    [control]="formGroup.get('cards')"
    id="cards"
    type="ngSelect"
    [selectValue]="cpxCards"
    [isClearableSelect]="false"
  ></frg-form-input>

  <div class="button-container" *ngIf="formGroup">
    <frg-button (click)="onClose()">
      <div title="Annuler">Annuler</div>
    </frg-button>
    <frg-button (activated)="selectCardFnc(formGroup.get('cards').value)">
      <div title="Valider">Valider</div>
    </frg-button>
  </div>
</div>